<template>
  <section class="lab-experience-featured-collections">
    <ActionLoader
      v-if="!hits"
      class="lab-experience-featured-collections__loader"
    />
    <template v-else-if="hits.length > 0">
      <LabsCollectionsFeatured
        :collectionsFeatured="hits"
        isHomepage
        class="lab-experience-featured-collections__featured"
      />
    </template>
  </section>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import LabsCollectionsFeatured from '@/components/lab-experience/LabsCollectionsFeatured.vue'
import { algoliaSearchMixin } from '@/helpers/mixins'
import CONSTANTS from '@/constants'

export default {
  name: 'LabExperienceFeaturedCollections',
  components: {
    ActionLoader,
    LabsCollectionsFeatured,
  },
  mixins: [algoliaSearchMixin],
  data() {
    return {
      isFetching: false,
      items: [],
    }
  },
  computed: {
    ...mapState({
      algoliaKeys: state => state.search.algoliaKeys,
      available_passes: state => state.auth.available_passes,
    }),
    ...mapGetters({
      profileInterestAreas: 'auth/profileInterestAreas',
      isSkillDiveB2CUser: 'auth/isSkillDiveB2CUser',
    }),
    hits() {
      return this.getIndexHits(this.algoliaKeys.searchIndex)
    },
  },
  async created() {
    const {
      algoliaKeys: { searchIndex },
    } = this

    const algoliaHelper = await this.initializeAlgoliaSearch(searchIndex, {
      facets: ['content_type', 'is_lab_experience', 'is_featured'],
      disjunctiveFacets: ['learning_areas.name'],
      hitsPerPage: 3,
    })

    algoliaHelper.addFacetRefinement('content_type', 'collection')

    let learningAreaFilters = []
    if (this.isSkillDiveB2CUser) {
      learningAreaFilters = this.available_passes
        .map(pass => CONSTANTS.SKILL_DIVE_B2C_PASSES_LEARNING_AREAS[pass.id])
        .filter(Boolean)
    } else {
      // B2B
      learningAreaFilters = CONSTANTS.LAB_EXPERIENCE.LEARNING_AREAS
    }
    if (learningAreaFilters.length < 3) {
      learningAreaFilters.forEach(la =>
        algoliaHelper.addDisjunctiveFacetRefinement(
          'learning_areas.name',
          la.name
        )
      )
    }

    algoliaHelper.search()
  },
}
</script>
<style lang="scss" scoped>
.lab-experience-featured-collections {
  padding: 30px 20px;
  max-width: 1440px;

  @include mobile {
    padding: 60px 20px 60px 30px;
  }
  @include desktop {
    padding: 0 100px 100px 100px;
    margin: auto;
  }

  ::v-deep .labs-collection-card {
    min-width: 280px;

    @include mobile {
      min-width: 350px;
    }

    @include desktop {
      min-width: unset;
    }
  }
}
</style>
